var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h5',[_vm._v(_vm._s(_vm.$t('objects.picker.equipment-chosen')))]),_vm._v(" "),(_vm.rmsObjects)?_c('grid',_vm._b({ref:"grid"},'grid',_vm.gridConfig,false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }